import {request} from './client.js'

/**
 * @return {Promise<{scenarios: import('./types.js').Scenario[]}>}
 */
export function listScenarios() {
    return request('GET', '/scenarios')
}

/**
 * @return {Promise<{active: import('./types.js').Scenario[]}>}
 */
export function listActiveScenarios() {
    return request('GET', '/scenarios/active')
}

/**
 * @return {Promise<import('./types.js').ScenarioType[]>}
 */
export function listScenarioTypes() {
    return request('GET', '/scenarios/types')
}

/**
 * @param {string} id
 * @return {Promise<import('./types.js').Scenario>}
 */
export function getScenario(id) {
    return request('GET', `/scenarios/${id}`)
}

/**
 * @param {string} id
 */
export function runScenario(id) {
    return request('POST', `/scenarios/${id}/run`)
}

/**
 * @param {string} id
 */
export function evaluateScenario(id) {
    return request('POST', `/scenarios/${id}/evaluate`)
}

/**
 * @param {string} id
 */
export function stopScenario(id) {
    return request('POST', `/scenarios/${id}/stop`)
}

/**
 * @param {string} id
 */
export function enableScenario(id) {
    return request('POST', `/scenarios/${id}/enable`)
}

/**
 * @param {string} id
 */
export function disableScenario(id) {
    return request('POST', `/scenarios/${id}/disable`)
}

/**
 * @param {Partial<import('./types.js').Scenario>} payload
 * @return {Promise<{scenario: import('./types.js').Scenario}>}
 */
export function createScenario(payload) {
    return request('POST', '/scenarios', {body: payload})
}

/**
 * @param {string} id
 * @param {Partial<import('./types.js').Scenario>} patch
 * @return {Promise<{scenario: import('./types.js').Scenario}>}
 */
export function updateScenario(id, patch) {
    return request('PUT', `/scenarios/${id}`, {body: patch})
}

/**
 * @param {string} id
 */
export function deleteScenario(id) {
    return request('DELETE', `/scenarios/${id}`)
}
